import { FC, useEffect, useState } from "react";
import { Grid, Tab, Tabs, Typography } from '@mui/material'
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../types";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useRenditionStore } from "../../hooks/useRenditionStore";
import { moneyCL, moneyFormat } from "../../toolbox/helpers/money-helpers";
import { useSelector } from "../../redux/store";
import { selectHeaderState } from "../../redux/slices/headerSlice";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { UploadTranfersModal } from "../Rendition/components/UploadTranfersModal";
import { useRenditionBuildingStore } from "../../hooks/useRenditionBuildingStore";
import { UploadTranfersBuildingModal } from "./components/UploadTransferBuildingModal";
import { useBuildingStore } from "../../hooks/useBuildingStore";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import ApartmentIcon from '@mui/icons-material/Apartment';

const initialColumns = [
  { type: 'options', field: 'options', label: 'Opciones' },
  { type: 'text', field: 'description', label: 'DESCRIPCION', align: 'center' },
  { type: 'text', field: 'building', label: 'EDIFICIO', align: 'center' },
  {
    type: 'text', field: 'amount_general', label: 'TOTAL GENERAL', align: 'center',
    format: (row) => moneyCL(row.amount_general)
  },
  {
    type: 'text', field: 'amount_individual', label: 'TOTAL INDIVIDUAL', align: 'center',
    format: (row) => moneyCL(row.amount_individual)
  },
  {
    type: 'text', field: 'amount_total', label: 'TOTAL', align: 'center',
    format: (row) => moneyCL(row.amount_total)
  },
  { type: 'detail', field: 'detail', label: '', align: 'center' },
]

export const RenditionBuildingList: FC = (props) => {

  const navigate = useNavigate();
  const { search } = useSelector(selectHeaderState);

  const { renditionBuildings, getRenditionsBuilding, deleteRenditionBuilding, setIdRenditionBuilding, setSelectedRenditionBuilding, getRenditionBuildingDetailPDF } = useRenditionBuildingStore();
  const { getBuildingByDepartments } = useBuildingStore()

  const [rowSelected, setRowSelected] = useState<any>('')
  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
  const [loading, setLoading] = useState(false);
  const [showModalTransfer, setShowModalTransfer] = useState<boolean>(false)
  const [downloading, setDownloading] = useState<boolean>(false)
  const [tabIndex, setTabIndex] = useState<number>(0)
  const columns = tabIndex === 0
    ? initialColumns
    : [
      ...initialColumns.slice(0, 3),
      {
        type: 'text',
        field: 'validation_status',
        label: 'PAGOS CERRADOS',
        align: 'center',
        format: (row) => row.validation_status === "2" ? "Sí" : "No"
      },
      ...initialColumns.slice(3)
    ]

  useEffect(() => {
    getBuildingByDepartments();
  }, [])

  useEffect(() => {
    getRenditionsApi();
  }, [search, tabIndex])

  const getRenditionsApi = async () => {
    try {
      setLoading(true)
      await getRenditionsBuilding({
        search,
        validation_status: tabIndex === 1 ? [1, 2] : [tabIndex]
      })
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const onEdit = (rowSelected) => {
    if (rowSelected.validation_status !== "0") return CustomSnackbar('error', 'Rendición Cerrada')
    setSelectedRenditionBuilding(rowSelected)
    navigate({ pathname: RoutesMap.RENDITION_ADMIN_BUILDING_OPEN })
  }

  const onDelete = (rowSelected) => {
    setRowSelected(rowSelected)
    setShowModalConfirm(true)
  }

  const onPaidIcon = (rowSelected) => {
    setSelectedRenditionBuilding(rowSelected)
    setIdRenditionBuilding(rowSelected.id)
    navigate({ pathname: RoutesMap.RENDITION_ADMIN_BUILDING_PAID })
  }

  const onDeleteConfirm = async () => {
    setShowModalConfirm(false)
    const response = await deleteRenditionBuilding(rowSelected.id)
    if (response === true) { getRenditionsApi() }
  }

  const onAdd = async () => {
    setIdRenditionBuilding(null)
    setShowModalTransfer(true)
  }

  const onHelper = async (rowSelected) => {
    setDownloading(true)
    const response = await getRenditionBuildingDetailPDF(rowSelected.id)
    if (response !== false) {
      const blob = new Blob([response], { type: 'application/pdf' })
      const bloblURL = URL.createObjectURL(blob)
      window.open(bloblURL, '_blank')
    }
    setDownloading(false)
  }

  const onGetDepartmentsRendition = async (rowSelected) => {
    console.log('rowSelected', rowSelected)
    setSelectedRenditionBuilding(rowSelected)
    navigate({ pathname: `/rendition-admin-building-department-list/${rowSelected.id}` })
  }

  const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
    setTabIndex(newValue)
  }

  return (
    <>
      {downloading && <CustomBackdrop open={true} />}
      <Grid item
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginBottom: '10px'
        }}
      >
        <Typography variant='h6' component='h1' gutterBottom sx={{ mt: 1, ml: 1 }} className='title-main'>
          LISTA DE RENDICIONES
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Tabs value={tabIndex} onChange={handleChange} aria-label="basic tabs">
          <Tab label="Abiertas" />
          <Tab label="Cerradas" />
        </Tabs>
        <CustomTable
          columns={columns}
          rows={renditionBuildings || []}
          loading={loading}
          onRowClick={() => { }}
          hasOptions
          onDelete={onDelete}
          onEdit={onEdit}
          onPaidIcon={onPaidIcon}
          // onAddFn={onAdd}
          onAddFnName={'REGISTRAR ABONO'}
          onHelper={onHelper}
          icon_helper={<PictureAsPdfIcon fontSize="small" />}
          tooltip_helper={'ver pdf'}
          onHelper2={onGetDepartmentsRendition}
          icon_helper2={<ApartmentIcon fontSize="small" />}
          tooltip_helper2={'ver departamentos'}
        />
      </Grid>

      {
        showModalConfirm && (
          <ModalConfirm
            open={showModalConfirm}
            closeModal={() => { setShowModalConfirm(false) }}
            onCancel={() => { setShowModalConfirm(false) }}
            onConfirm={onDeleteConfirm}
          />
        )
      }
      {
        showModalTransfer && (
          <UploadTranfersBuildingModal
            open={showModalTransfer}
            closeModal={() => { setShowModalTransfer(false) }}
            isAdmin={true}
            isPayment={true}
          />
        )
      }
    </>)
}